import { useNavigate } from 'react-router-dom';
import type { FC } from 'react';
import { useThemeToggle } from '../ThemeProvider/WorkingThemeProvider';
import styles from './Footer.module.scss';

const partnerLogos = [
  { src: '/images/logo_dbbs.svg', alt: 'DBBS Lab', url: 'https://dangelo.unipv.it', height: 36 },
  { src: '/images/logo_unipv.svg', alt: 'University of Pavia', url: 'https://en.unipv.it/en', height: 36 },
  { src: '/images/logo_ebrains.svg', alt: 'EBRAINS', url: 'https://www.ebrains.eu/', height: 36 },
  { src: '/images/logo_ebrains_italy.png', alt: 'EBRAINS Italy', url: 'https://www.ebrains-italy.eu/', height: 32 },
];

const navigationLinks = [
  { label: 'Home', path: '/' },
  { label: 'Model exploration', path: '/model-exploration' },
  { label: 'Tools', path: '/tools' },
  { label: 'Learning', path: '/learning' },
  { label: 'Contact', path: '/contact' },
  { label: 'Legal', path: '/legal' },
];

const Footer: FC = () => {
  const navigate = useNavigate();
  const { themeMode } = useThemeToggle();

  return (
    // The footer is a permanent graphite band. Inside a dark page it steps one
    // value deeper so it still separates from the content above.
    <footer
      className={styles.footer}
      data-theme={themeMode === 'dark' ? 'instrument-deep' : 'instrument'}
    >
      <div className={styles.footer__grid}>
        <section className={styles.footer__column}>
          <span className={styles.footer__label}>Partners &amp; affiliations</span>
          <div className={styles.footer__partners}>
            {partnerLogos.map((logo) => (
              <a
                key={logo.alt}
                href={logo.url}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.footer__partner}
              >
                <img src={logo.src} alt={logo.alt} style={{ height: logo.height }} />
              </a>
            ))}
          </div>
        </section>

        <nav className={styles.footer__column} aria-label="Site map">
          <span className={styles.footer__label}>Site map</span>
          <div className={styles.footer__links}>
            {navigationLinks.map((link) => (
              <a
                key={link.path}
                href={link.path}
                className={styles.footer__link}
                onClick={(e) => {
                  e.preventDefault();
                  navigate(link.path);
                }}
              >
                {link.label}
              </a>
            ))}
          </div>
        </nav>
      </div>

      <div className={styles.footer__base}>
        <span>
          © {new Date().getFullYear()} Department of Brain and Behavioral Sciences, University of Pavia
        </span>
        <span className={styles.footer__contact}>
          <a href="https://github.com/dbbs-lab" target="_blank" rel="noopener noreferrer">
            github.com/dbbs-lab
          </a>
          <a href="mailto:neurocomp.dbbs@unipv.it">neurocomp.dbbs@unipv.it</a>
          <a href="https://dangelo.unipv.it" target="_blank" rel="noopener noreferrer">
            dangelo.unipv.it
          </a>
        </span>
      </div>
    </footer>
  );
};

export default Footer;
